import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HeadersModule } from '@shared/core/components/headers';
import { LoyaltyModule } from '@shared/core/modules/loyalty';
import { DropDownModule } from '@shared/core/components/dropDown';
import { ProjectionModule } from '@shared/core/components/projection';
import { BadgesModule } from '@shared/core/components/badges';

import { LinkModule } from '@shared/core/components/link';

import { AuthAccountBalanceModule } from '../authAccountBalance';

import { AuthLinkComponent } from './auth-link.shared.component';

@NgModule({
    declarations: [
        AuthLinkComponent
    ],
    imports: [
        CommonModule,
        DropDownModule,
        ProjectionModule,
        LinkModule,
        HeadersModule,
        LoyaltyModule,
        BadgesModule,
        AuthAccountBalanceModule,
    ],
    exports: [
        AuthLinkComponent
    ],
})
export class AuthLinkModule { }
